// Imports
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import company from '../../../../shareables/company';
import FullPageErrorTemplate, { SecondaryButton } from '../full-page-error-template';


// Function component
const UnexpectedError: React.FC = () => (
	<FullPageErrorTemplate
		documentTitle='Unexpected error'
		heading='Something went wrong'
		description='An unexpected issue occurred, and our engineering team has been notified.'
	>
		<SecondaryButton href={`https://help.${company.productionDomain ?? ''}/`} color='gray' target='_blank'>
			<FontAwesomeIcon icon={faCircleQuestion} /> <span>Contact us</span>
		</SecondaryButton>
	</FullPageErrorTemplate>
);

export default UnexpectedError;
